import { Notify } from 'quasar';

export function notifySuccess(
  successMessage: string | null = null,
  options: { html?: boolean } = {},
) {
  if (successMessage) {
    Notify.create({
      color: 'positive',
      textColor: 'white',
      message: successMessage,
      html: options.html ?? false,
    });
  }
}
